import { HistoryIcon } from "@graphiql/react";
/* empty css          */
import { History } from "./components.js";
import { HistoryContextProvider, useHistory, useHistoryActions } from "./context.js";
const HISTORY_PLUGIN = {
  title: "History",
  icon: HistoryIcon,
  content: History
};
export {
  HISTORY_PLUGIN,
  History,
  HistoryContextProvider,
  useHistory,
  useHistoryActions
};
//# sourceMappingURL=index.js.map
